var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1312 6.50797V4.50478C11.1312 3.45301 11.1312 2.92712 10.9265 2.5254C10.7464 2.17203 10.4591 1.88474 10.1058 1.70469C9.70405 1.5 9.17817 1.5 8.12639 1.5H4.12002C3.06824 1.5 2.54236 1.5 2.14063 1.70469C1.78727 1.88474 1.49997 2.17203 1.31992 2.5254C1.11523 2.92712 1.11523 3.45301 1.11523 4.50478V11.0151C1.11523 12.0669 1.11523 12.5928 1.31992 12.9945C1.49997 13.3479 1.78727 13.6352 2.14063 13.8152C2.54236 14.0199 3.06824 14.0199 4.12002 14.0199H6.1232M6.4362 7.13397H3.61922M4.24522 9.63795H3.61922M8.62719 4.62998H3.61922",
    stroke: "#0065B3",
    strokeWidth: 1.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_7259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31673 13.2478C10.0259 13.5624 10.8706 13.5453 11.594 13.1277C12.7958 12.4338 13.2075 10.8971 12.5137 9.69532L12.4398 9.56732M8.16145 12.208C7.4676 11.0062 7.87936 9.46951 9.08116 8.77565C9.80451 8.35803 10.6492 8.34094 11.3584 8.65557M7.52734 12.2328L8.33496 12.4492L8.55136 11.6415M12.1238 10.2617L12.3402 9.45404L13.1479 9.67044",
    stroke: "#0065B3",
    strokeWidth: 0.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_7259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.09463,
    height: 7.09463,
    fill: "white",
    transform: "translate(6.79102 7.4043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateFile);
export default __webpack_public_path__ + "static/media/updateFile.aee43fc4e8143e81ade9715ac973b031.svg";
export { ForwardRef as ReactComponent };